import { useTranslation } from 'react-i18next';
import { Navigation } from '@cbridge-utils/navigation';
import { RouteSegments } from '../routingClientAdmin.interface';

export const useSettingsNavigationItems = () => {
  const { t } = useTranslation();

  const items: Navigation = [
    {
      kind: 'header',
      title: t('text:navigation.config.settings.title'),
    },
    {
      kind: 'page',
      segment: RouteSegments.Settings.Users,
      title: t('text:navigation.config.settings.users'),
    },
    {
      kind: 'page',
      segment: RouteSegments.Settings.Streams,
      pattern: [
        RouteSegments.Settings.Streams,
        `${RouteSegments.Pools.Streams}{/*path}`,
      ],
      title: t('text:navigation.config.settings.streams'),
    },
    {
      kind: 'page',
      segment: RouteSegments.Settings.Servers,
      pattern: `${RouteSegments.Settings.Servers}{/:id}`,
      title: t('text:navigation.config.settings.tradingServers'),
    },
    {
      kind: 'page',
      segment: RouteSegments.Settings.LiquidityProviders,
      pattern: `${RouteSegments.Settings.LiquidityProviders}{/:id}`,
      title: t('text:navigation.config.settings.lps'),
    },
    {
      kind: 'page',
      segment: RouteSegments.Config.Alerts,
      pattern: `${RouteSegments.Config.Alerts}{/*path}`,
      title: t('text:navigation.config.settings.alerts.title'),
    },
  ];

  return items;
};
